import type { Faq } from '../../../components/ui/FaqList';

/**
 * General questions people search before shipping from Saudi Arabia.
 * Feeds both the Home FAQ accordion and its FAQPage JSON-LD. Keep facts in
 * line with the service pages (transit times, countries, branches).
 */
export const HOME_FAQS: Faq[] = [
  {
    q: 'How do I send cargo from Saudi Arabia to India?',
    a: "Book online or call your nearest Sahari Cargo branch. We collect the cargo from your address in Saudi Arabia, pack and number every box, handle export and Indian import customs, and deliver it to the recipient's door by air cargo or sea freight.",
  },
  {
    q: 'How much does it cost to send cargo from Saudi Arabia?',
    a: "The price depends on the weight and size of your shipment, the destination country, and whether you choose air or sea. Request a free quote and we'll give you an exact price — the price we quote is the price you pay, with no hidden charges.",
  },
  {
    q: 'How long does cargo take from Saudi Arabia?',
    a: 'Door-to-door cargo usually takes 10–15 days by air or sea, depending on the destination. Request a quote for the exact timeline on your route.',
  },
  {
    q: 'Which cities in Saudi Arabia do you pick up from?',
    a: 'We have 12 branches across the Kingdom — Jeddah, Makkah, Madinah, Riyadh, Taif, Yanbu, Rabigh, Abha, Khamis Mushait, Jizan, Muhayil, and Duba. We collect from your home or office, or you can drop your cargo at the nearest branch.',
  },
  {
    q: 'Which countries do you ship to?',
    a: "India, the Philippines, Bangladesh, Pakistan, Nepal, Sri Lanka, Malaysia, Singapore, Brunei, and the United Kingdom (Malaysia and Brunei by air cargo only). If your destination isn't listed, contact us — we can usually confirm the same day whether we can ship there.",
  },
  {
    q: 'Do you handle customs clearance?',
    a: "Yes. We prepare the export documents in Saudi Arabia and clear import customs at the destination. You only need to declare the contents of your shipment correctly when you book.",
  },
  {
    q: 'How can I track my cargo?',
    a: 'Every shipment gets a tracking number when it is booked. Enter it on our Tracking page to see each stage, from pickup in Saudi Arabia through to delivery.',
  },
  {
    q: 'Is my cargo insured?',
    a: 'Cargo insurance is available for your shipment, protecting it from the moment we collect it until it reaches the destination. Ask for insurance when you book.',
  },
];
